import React, { Dispatch, SetStateAction } from 'react';

import { useTranslation } from 'react-i18next';

import {
  ActiveChannelTypeEnum,
  ChannelType,
  DeprecatedChannelTypeEnum,
  PROPERTY_TYPES,
  TENANT_TYPES,
} from 'constants-channel';

import { ChannelSearchHierarchiesEnum } from 'components/lane/ChannelSearch';
import ChannelSelector, {
  ChannelSelectorModesEnum,
} from 'components/lane/ChannelSelector';

import { S } from 'components/typography';

import { ChannelManagementModal } from './ChannelManagementModal';
import { Channel } from 'packages/lane-shared/types/ChannelType';

export function ChangeParentModal({
  selectedChannel,
  isOpen,
  setIsOpen,
  selectedParentChannel,
  setSelectedParentChannel,
  onParentSelected,
}: {
  selectedChannel: any;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  selectedParentChannel: Channel | null;
  setSelectedParentChannel: Dispatch<SetStateAction<Channel | null>>;
  onParentSelected: () => Promise<void>;
}) {
  const { t } = useTranslation();

  const isPropertyChannel =
    selectedChannel?.channel?.type === ActiveChannelTypeEnum.Property;

  const types: ChannelType[] = isPropertyChannel
    ? [...PROPERTY_TYPES]
    : // @ts-expect-error ????????
      TENANT_TYPES.concat(Object.keys(DeprecatedChannelTypeEnum));

  const body = (
    <>
      <ChannelSelector
        // @ts-ignore
        onChannelSelected={(channel: Channel) =>
          setSelectedParentChannel(channel)
        }
        hierarchies={[ChannelSearchHierarchiesEnum.Parent]}
        types={types}
        modes={[ChannelSelectorModesEnum.Search]}
        disableTypeSelect
        disableStorage
        shouldHighlightOnClick
      />
      <S style={{ padding: '1em' }}>
        {t(
          'web.admin.portalManagement.channelManagement.changeParent.modal.joinRules',
          { channelName: selectedChannel?.channel?.name }
        )}
      </S>
    </>
  );

  return (
    <ChannelManagementModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={() => setSelectedParentChannel(null)}
      title={t(
        'web.admin.portalManagement.channelManagement.changeParent.modal.title'
      )}
      description={t(
        'web.admin.portalManagement.channelManagement.changeParent.modal.description',
        { channelName: selectedChannel?.channel?.name }
      )}
      body={body}
      onClick={onParentSelected}
      size="large"
      disableConfirm={!selectedParentChannel}
    />
  );
}
